import { checkSize } from "./utils.mjs";

const resizeCells = table => {
  //Get the total number of fake rows we'll need to create.
  const totalRows = table.querySelectorAll("th").length;
  //Empty array to hold the new "row" heights.
  let rowHeights = [];

  for (let index = 0; index < totalRows; index++) {
    //Because columns are now "rows", we have to get every cell that is the nth-child of its row.
    const fakeRowCells = table.querySelectorAll(
      `td:nth-child(${index + 1}), th:nth-child(${index + 1})`
    );
    //Empty array to hold the heights of each cell in the row.
    const cellHeights = [];

    //Loop through each cell in the row and get its height.
    fakeRowCells.forEach(cell => {
      cellHeights.push(cell.offsetHeight);
    });
    //Get the maximum height of all the cells in the row and add it to the rowHeights array.
    rowHeights.push(Math.max(...cellHeights));

    //Set the CSS variable for the row height.
    table.style.setProperty(
      `--wc-row-height-${index + 1}`,
      `${rowHeights[index]}px`
    );
    //Set the CSS variable for the special cell that goes full height.
    //It has to be done after the others so it doesn't throw off the whole row.
    table.style.setProperty(
      `--wc-full-height`,
      `100%`
    );
  }
};

window.addEventListener("DOMContentLoaded", () => {
  const breakpoint = 768;
  const tabEls = document.querySelectorAll('button[data-bs-toggle="tab"]');

  const checkAndListen = (table, breakpoint, resized = false) => {
    if (checkSize(breakpoint)) {
      resizeCells(table);
      resized = true;
    } else {
      addEventListener("resize", e => {
        if (checkSize(breakpoint)) {
          resizeCells(table);
          resized = true;
        }
      });
    }
    return resized;
  };

  tabEls.forEach((tabEl, i) => {
    const tableID = tabEl.getAttribute("aria-controls");
    const table = document.getElementById(tableID);
    let resized = false;

    //Fix the one you can see
    if (tabEl.classList.contains("active") && !resized) {
      resized = checkAndListen(table, breakpoint);
    } else {
      //Otherwise add a listener to the tab to check when it's active
      //Tab must be active to get cell heights
      tabEl.addEventListener("shown.bs.tab", event => {
        if (!resized) {
          resized = checkAndListen(table, breakpoint);
        }
      });
    }
  });
});
